import 'rxjs/add/observable/of';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { classToPlain, plainToClass } from 'class-transformer';
import { Guid } from 'guid-typescript';
import { CookieService } from 'ngx-cookie-service';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Login, newDate, ORVSession, SessionStrategy, SharedDataService, Staff, User } from 'orv-ui-base-lib';
import { of } from 'rxjs/internal/observable/of';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService {


	token: string;
	tokenCookie = 'ORVAdminToken';
	userCookie = 'ORVAdminUser';
	uuidCookie = 'ORVAdminUuid';
	sidebarCookie = 'ORVAdminSidebar';
	eventLoginCookie = 'ORVNewLogin';
	chartCookie = 'ORVAdminChart';

	constructor(
		@Inject(LOCAL_STORAGE) private storage: StorageService,
		protected http: HttpClient,
		private cookieService: CookieService,
		private sharedDataService: SharedDataService,
	) {
		sharedDataService.currentToken.subscribe(token => { this.token = token; });
	}

	// login(login: Login) {
	// 	return this.http.get('/ws/jwt/token', {}).mergeMap((token: any) => {
	// 		const httpOptions = {
	// 			headers: new HttpHeaders({
	// 				'Authorization': 'Bearer: ' + token.jwt
	// 			}),
	// 		};
	// 		return this.http.post('/ws/orvuser/login', classToPlain(login), httpOptions)
	// 			.pipe(map(res => {
	// 				const s: Staff = plainToClass(Staff, res as Object);
	// 				// this.sharedDataService.setLoggedUser(s);
	// 				this.storage.set(this.tokenCookie, s.token);
	// 				this.storage.set(this.userCookie, s.id + '');
	// 				this.storage.set(this.uuidCookie, Guid.raw());
	// 				this.storage.set(this.eventLoginCookie, Math.round(newDate(true).getTime() / 1000));
	// 				return s;
	// 			}));
	// 	});
	// }

	loginV2(login: Login) {
		const strategy = SessionStrategy.NEW;

		return this.http.get('/ws/jwt/token', {}).mergeMap((token: any) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Authorization': 'Bearer: ' + token.jwt
				}),
			};

			return this.http.post('/ws/orvuser/start', classToPlain(login), httpOptions).mergeMap((user: User) => {

				const httpOptionsStart = {
					headers: new HttpHeaders({
						'Authorization': 'Bearer: ' + user.token
					}),
				};

				this.storage.set(this.tokenCookie, user.token);
				this.storage.set(this.userCookie, user.id + '');
				this.storage.set(this.uuidCookie, Guid.raw());
				this.storage.set(this.eventLoginCookie, Math.round(newDate(true).getTime() / 1000));

				return this.http.get(`/ws/session/${strategy}`, httpOptionsStart)
					.pipe(map((response: any) => {
						const session: ORVSession = plainToClass(ORVSession, response as Object);
						session.orvuser = plainToClass(Staff, user as Object);
						this.sharedDataService.setSessionData(session);
						return session.orvuser;
					}));
			});

		});
	}


	logout() {
		this.storage.remove(this.tokenCookie);
		this.storage.remove(this.userCookie);
		this.storage.remove(this.sidebarCookie);
		this.storage.remove(this.uuidCookie);
		this.storage.remove(this.eventLoginCookie);
		this.sharedDataService.removeLoggedUser();
	}

	// renew() {
	// 	const httpOptions = {
	// 		headers: new HttpHeaders({
	// 			'Authorization': 'Bearer: ' + this.getToken()
	// 		}),
	// 	};
	// 	return this.http.get('/ws/jwt/renew', httpOptions)
	// 		.pipe(map((token: any) => {
	// 			this.storage.set(this.tokenCookie, token.jwt);
	// 			return token;
	// 		}));
	// }

	renewV2() {
		const httpOptions = {
			headers: new HttpHeaders({
				'Authorization': 'Bearer: ' + this.getToken()
			}),
		};
		return this.http.get('/ws/jwt/renewbo', httpOptions)
			.pipe(map((token: any) => {
				this.storage.set(this.tokenCookie, token.jwt);
				return token;
			}));
	}

	renewSession(strategy: SessionStrategy = SessionStrategy.NEW, full?: boolean) {
		return this.http.get(`/ws/session/${strategy}`)
			.pipe(map((res: any) => {
				const session: ORVSession = plainToClass(ORVSession, res as Object);
				if (full) this.sharedDataService.setSessionData(session);
				else this.sharedDataService.setFeatures(session.features);
				return session;
			}));
	}


	resetPwd(id: number, login: Login) {
		return this.http.get('/ws/jwt/token', {}).mergeMap((token: any) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Authorization': 'Bearer: ' + token.jwt
				}),
			};
			return this.http.post(`/ws/orvuser/${id}/updatepassword`, classToPlain(login), httpOptions)
				.pipe(map(res => {
					const s: Staff = plainToClass(Staff, res as Object);
					// this.sharedDataService.setLoggedUser(s);
					this.storage.set(this.tokenCookie, s.token);
					this.storage.set(this.userCookie, s.id + '');
					this.storage.set(this.uuidCookie, Guid.raw());
					return s;
				}));
		});
	}

	resetPassword(user: User) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Authorization': 'Bearer: ' + this.getToken()
			}),
		};
		return this.http.post(`/ws/orvuser/${user.id}/resetpassword`, classToPlain(user), httpOptions);
	}

	forcePasswordChange(user: User) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Authorization': 'Bearer: ' + this.getToken()
			}),
		};
		return this.http.post(`/ws/orvuser/${user.id}/forcepwdchange`, classToPlain(user), httpOptions);
	}

	hasCookie() {
		return this.storage.get(this.tokenCookie) && this.storage.get(this.userCookie);
	}

	getUuid() {
		return this.storage.get(this.uuidCookie);
	}

	getToken() {
		return this.storage.get(this.tokenCookie);
	}

	getUserId() {
		return this.storage.get(this.userCookie);
	}

	// getLoggedUser() {
	// 	const tokenCookie = this.storage.get(this.tokenCookie);
	// 	const userCookie = this.storage.get(this.userCookie);
	// 	// this.sharedDataService.setToken(token);

	// 	if (tokenCookie && userCookie) {
	// 		return this.getUser(userCookie).map(user => {
	// 			if (user) {
	// 				this.token = user.token;
	// 				this.sharedDataService.setLoggedUser(user);
	// 			}
	// 			return user;
	// 		});
	// 	}
	// 	return of(undefined);
	// }

	getLoggedUser() {
		const tokenCookie = this.storage.get(this.tokenCookie);
		const userCookie = this.storage.get(this.userCookie);
		// this.sharedDataService.setToken(token);

		if (tokenCookie && userCookie) {
			return this.http.get(`/ws/orvuser/${userCookie}`).mergeMap((user: User) => {

				const httpOptionsStart = {
					headers: new HttpHeaders({
						'Authorization': 'Bearer: ' + user.token
					}),
				};

				return this.http.get(`/ws/session/${SessionStrategy.CURRENT}`, httpOptionsStart)
					.pipe(map((response: any) => {
						const session: ORVSession = plainToClass(ORVSession, response as Object);
						session.orvuser = plainToClass(Staff, user as Object);
						this.sharedDataService.setSessionData(session);
						return session.orvuser;
					}));

			});
		}
		return of(undefined);
	}

	// getUser(user: string): Observable<Staff> {
	// 	return 
	// 		.map(res => plainToClass(Staff, res as Object));
	// 	// return Observable.of(new Staff()); //mock user endpoint
	// }

	setSidebarCookie(value: string): void {
		this.cookieService.set(this.sidebarCookie, value);
	}

	getSidebarCookie(): string {
		return this.cookieService.get(this.sidebarCookie);
	}

	setChartCookie(value: string): void {
		this.cookieService.set(this.chartCookie, value);
	}

	getChartCookie(): string {
		return this.cookieService.get(this.chartCookie);
	}

}

